import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {

  captcha:'/captcha/',
  login:'/login/',
}



// export function captcha () {
//   return axios({
//     url: api.orderdetail+id+'/',
//     method: 'get',

//   })
// }
export function captcha (params) {
  return axios({
    url: api.captcha,
    method: 'get',
    params
  })
}
export function login (data) {
  return axios({
    url: api.login,
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/views/login/api.js